import { type AxiosError } from 'axios'
import { reportError } from '@/utils/error-reporter'

interface ProblemDetails {
  title?: string
  detail?: string
}

// Ids are replaced so failures group per endpoint, e.g. PATCH /units/:id
function requestSignature(error: AxiosError): string {
  const method = error.config?.method?.toUpperCase() ?? 'REQUEST'
  const path = (error.config?.url ?? '')
    .split('?')[0]
    .replace(/^\/?/, '/')
    .replace(/\/\d+(?=\/|$)/g, '/:id')

  return `${method} ${path}`
}

// Called for every failed request made through useApiClient, so 5xx responses
// are reported however the request was made - including calls that don't go
// through the query helpers, like sign in.
export function reportServerError(error: AxiosError): void {
  const status = error.response?.status
  if (status === undefined || status < 500) {
    return
  }

  const errorResponse = error.response?.data as ProblemDetails | undefined
  const signature = requestSignature(error)

  reportError(error, {
    severity: 'warning',
    context: signature,
    groupingHash: `${signature} ${status}`,
    metadata: {
      section: 'request',
      values: {
        method: error.config?.method?.toUpperCase(),
        url: error.config?.url?.split('?')[0],
        status,
        title: errorResponse?.title,
        detail: errorResponse?.detail
      }
    }
  })
}
